<template>
    <div class="col-auto setting category-setting" :data-mub="mubBlock.categoryCatalog" v-click-outside="outsideClickNested">
        <span class="description title"> {{ kStrings.kCATEGORY + ':' }} </span>
        <div @mousedown="nestedMainHandler" @mouseover="loadCategories" class="w-100 action" :class="{ 'active' : openMenu}">
            <span class="description"> {{ defaultOption }} </span>
            <i class="ecom-chevron-down"/>
        </div>
        <transition name="fade">
            <div v-if="loadedCategories && builtMenu && openMenu" class="nested-menu">
                <ul class="drop-options">
                    <li v-if="!builtMenu.length" class="list-option empty-option">
                        {{ kStrings.kNO_RESULTS_CRITERIA }}
                    </li>
                    <li v-for="(opt, index) in builtMenu" 
                        class="list-option"
                        :class="{'selected' : hoverLevelOneId == opt.id}"
                        :key="'l1-'+index" 
                        @mouseover="nestedHoverHandler(opt)"
                        @click="nestedClickHandler(opt)"
                    > 
                        {{ opt.name }}
                    </li>
                </ul>
                
                <!-- max 3 levels, nested UL/LI goes stacked instead for horizontal sub menus -->
                <!-- level 2 -->
                <ul v-if="levelTwo" class="drop-options sub-level"
                    :class="{'no-scroll' : noMenuScroll && levelThree}"
                >
                    <li v-for="(subOpt, subIndex) in levelTwo" 
                        class="list-option" 
                        :class="{'selected' : hoverLevelTwoId == subOpt.id}"
                        :key="'l2-'+subIndex" 
                        @mouseover="nestedHoverHandler(subOpt)"
                        @click="nestedClickHandler(subOpt)"
                    >
                        {{ subOpt.name }}
                    </li>
                </ul>
                <!-- level 3 -->
                <ul v-if="levelThree" class="drop-options sub-level">
                    <li v-for="(subOpt, subIndex) in levelThree" 
                        class="list-option"
                        :class="{'selected' : hoverLevelTreeId == subOpt.id}"
                        v-bind:key="'l3-'+subIndex" 
                        @mouseover="nestedHoverHandler(subOpt)"
                        @click="nestedClickHandler(subOpt)"
                    >
                        {{ subOpt.name }}
                    </li>
                </ul>
            </div>
            <div v-if="!loadedCategories && openMenu" class="nested-menu">
                <div class="drop-options" style="width:230px; height:320px;">
                    <MuffinLoader />
                </div>
            </div>   
        </transition>
    </div>
</template>

<script>

import {store} from '@/store/catalog';
import {isEmpty} from 'lodash-es';

import request from '@/Utilities/httpRequest';
import { clickOutside } from '@/api/vueDirectives';
import MuffinLoader from '@/components/Muffin/Loader';

export default {
    store,
    name: 'NestedMenu',
    components: {
        MuffinLoader
    },
    props: {},
    data() {
        return {
            openMenu: false,
            searchTextMenu: null,
            noMenuScroll: false,
            // level 2 & 3 objects
            levelTwo: null,
            levelThree: null,
            menuOutOfBounds: false,
            // persistent hover effect between nested menus, maybe not so pro #shame
            hoverLevelOneId: null,
            hoverLevelTwoId: null,
            hoverLevelTreeId: null,
            // categories are loaded when mouse is over/click category
            loadedCategories: false,
            loading: false,
        };
    },
    computed: {
        mubBlock() {
            return this.$store.getters.extras.mubBlock;
        },
        kStrings() {
            return this.$store.getters.kStrings;
        },
        builtMenu() {
            const menuData = this.menuData;
            if(!menuData || isEmpty(menuData.detailedMenu)) {
                return null;
            }
            
            if(this.searchTextMenu && this.searchTextMenu.length >= 2) {
                return this.menuSearch(menuData.allCategories, this.searchTextMenu);
            }
            
            return menuData.detailedMenu;
        },
        defaultOption() {
            if(!this.menuData || !this.menuData.categoryListId) {
                return this.kStrings.kSHOW_ALL;
            }
            
            return this.menuData.defaultDescription;
        },
        menuData() {
            const categories = this.$store.getters.categories;
            return isEmpty(categories) ? null : categories;
        },
        curCategoryId() {
            const menuData = this.menuData;
            return menuData && menuData.categoryListId ? menuData.categoryListId : null;
        },
       /* filteredSearchMenu() {
            return this.menuSearch(this.builtMenu, this.searchTextMenu);
        }*/
    },
    watch: {
       /* levelTwo(value) { 
            console.log('level two: ', value);
        },
        levelThree(value) {
            console.log('level three: ', value);
        },*/
        /*builtMenu(value) {
            console.log('builtMenu: ', value);
        }*/
    },
    created() {
        if(this.menuData && this.menuData.hasOwnProperty('detailedMenu') && this.menuData.detailedMenu !== null){
            this.loadedCategories = true;
        }
    },
    mounted() {
        //console.log('menu data: ', this.menuData);
    },
    methods: {
        outsideClickNested() {
            // directive requires to be function (right?)
            this.openMenu = false;
            // pre select categories
            this.preSelectCategories();
        },
        resetMenuEvents() {
            this.levelTwo = null;
            this.levelThree = null;
            // shame
            this.hoverLevelOneId = null;
            this.hoverLevelTwoId = null;  
            this.hoverLevelTreeId = null;  
        },
        // main menu only
        nestedMainHandler() {
            this.openMenu = !this.openMenu;
        },
        // hover handler
        nestedHoverHandler(item) {
            if(!item || (this.searchTextMenu && this.searchTextMenu.length > 2)) { 
                return 
            }
            
            if(item.level == 1) {
                this.resetMenuEvents();
            }
            // if item has sub categories, the respective level menu = item object
            //console.log('nestedHoverHandler ', level)
            switch (item.level) {
                case 1:
                    this.hoverLevelOneId = item.id;
                    //this.levelTwo = item.subCategories ? item.subCategories : null;
                    this.levelTwo = this.getSubCategories(item);
                    break;
                case 2:
                    this.hoverLevelTwoId = item.id;
                    //this.levelThree = item.subCategories ? item.subCategories : null;
                    this.levelThree = this.getSubCategories(item);
                    break;
                case 3:
                    this.hoverLevelTreeId = item.id;
                    break;
            }

           /* console.log('level 1 hover: ', this.hoverLevelOneId);
            console.log('level 2 hover: ', this.hoverLevelTwoId);*/
        },
        // click handler
        nestedClickHandler(item = null) {
            if(!item) { return }
            this.openMenu = false;
            this.resetMenuEvents();
            
            window.location.href = item.url;
        },
        getSubCategories(item){
            if(!item.hasOwnProperty('children')){
                return null;
            }

            let list = [];
            const categories = this.menuData.allCategories;
            for(let i = 0; i < item.children.length; i++){
                const id = item.children[i];
                if(categories.hasOwnProperty(id)){
                   list.push(categories[id]);
                }
            }
            return list;
        },
        // menu persistent "selection/hover" effect handler -> PRO MODE FAILED :(
        /*belongsToCategory(item = null, level = null) {
            let belongsTo = false;
            if(!item || !level) { return }
            
            console.log('selected category: ', item);
            switch (item.level) {
                case 1:
                    belongsTo = levelTwo && !isEmpty(levelTwo.filter(ct => ct.parentId == item.id));
                    break;
                case 2:
                    belongsTo = this.levelThree && this.levelThree.parentId && this.levelThree.parentId == item.id;
                    break;
            }
            
            return belongsTo;
        }*/
        menuSearch(options, query) {
            if (!isEmpty(options)) {
                let text = query.toLowerCase();
                this.resetMenuEvents();
                if(typeof options === 'array'){
                    return options.filter(value => value.name.toLowerCase().includes(text));
                }
                // do search
                let list = [];
                const categories = this.menuData.allCategories;
                for(let k in categories){
                    const item = categories[k];
                    if(item.name.toLowerCase().includes(text)){
                        list.push(item);
                    }
                }
                return list;

            }
            
            return [];
        },
        async loadCategories(){
            if(!this.loading){
                // get URL
                const urls = this.$store.getters.urls;
                if(!urls || !urls.menuCatalog){
                    return;
                }
                // loading data
                this.loading = true;
                // get data from URL
                const response = await request.get(urls.menuCatalog);
                // stopped loading
                this.loading = false;
                // check response
                if(!response || !response.data || !response.data.menu || !response.data.categories){
                    return;
                }
                // udpate menu and category list
                this.$store.dispatch('updateMenuAndCategories', response.data);
                // pre select categories
                this.preSelectCategories();
                // done
                this.loadedCategories = true;
            }
        },
        preSelectCategories(){
            const id =this.curCategoryId;
            const all = this.menuData ? this.menuData.allCategories : {};
            if(!id || !all || !all.hasOwnProperty(id)){
                return ;
            }
//            console.log('pre select ', id, all[id]);
            const current = all[id];
            const parent = all.hasOwnProperty(current.parent) ? all[current.parent] : null;
            if(current.level === 3 && parent && all.hasOwnProperty(parent.parent)){
                this.nestedHoverHandler(all[parent.parent]);
                this.nestedHoverHandler(parent);
                this.nestedHoverHandler(current);
            }
            else if(current.level === 2 && parent){
                this.nestedHoverHandler(parent);
                this.nestedHoverHandler(current);
            }
        }
    },
};
</script>

<style scoped>

</style>